import { Directionality } from '@angular/cdk/bidi';
import {
  OverlayPositionBuilder,
  Overlay,
  ScrollStrategyOptions,
  OverlayKeyboardDispatcher
} from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { ApplicationRef, ComponentFactoryResolver, Inject, Injectable, Injector, NgZone } from '@angular/core';
import { AiDynamicOverlayContainer } from './dynamic-overlay-container';

@Injectable()
export class AiDynamicOverlay extends Overlay {

  private _dynamicOverlayContainer: AiDynamicOverlayContainer;

  constructor(scrollStrategies: ScrollStrategyOptions,
              _overlayContainer: AiDynamicOverlayContainer,
              _componentFactoryResolver: ComponentFactoryResolver,
              _positionBuilder: OverlayPositionBuilder,
              _keyboardDispatcher: OverlayKeyboardDispatcher,
              _appRef: ApplicationRef,
              _injector: Injector,
              _ngZone: NgZone,
              @Inject(DOCUMENT) private document: any,
              _directionality: Directionality) {

    super(scrollStrategies,
      _overlayContainer,
      _componentFactoryResolver,
      _positionBuilder,
      _keyboardDispatcher,
      _injector,
      _ngZone,
      document,
      _directionality);

    this._dynamicOverlayContainer = _overlayContainer;
  }

  public setContainerElement(containerElement: HTMLElement): void {
    this._dynamicOverlayContainer.setContainerElement(containerElement);
  }
}
